<script lang="ts">
  import { arrowLeftIcon } from '@nrk/core-icons';
  import Icon from './Icon.svelte';

  interface Props {
    fallbackHref?: string;
  }

  let { fallbackHref = '#/' }: Props = $props();

  const handleClick = (e: MouseEvent) => {
    // Check if we have meaningful history to go back to
    // history.length includes the current page, so > 1 means there's somewhere to go back
    if (window.history.length > 1) {
      e.preventDefault();
      history.back();
    }
    // Otherwise, the fallbackHref link will be followed
  };
</script>

<a href={fallbackHref} onclick={handleClick} class="btn tertiary back-btn">
  <Icon svg={arrowLeftIcon} />
  Tilbake
</a>

<style>
  .back-btn {
    gap: var(--space-1);
  }
</style>
